import {NetworksFilter} from './networks.model';
import {Network, NetworkController, NetworkStatusSignalR} from '../../models/network/network.interface';
import {FilterObject} from '../../../shared/models/FilterBarObject';

export class LoadNetworks {
  static type = '[Networks] Load Networks';
}

export class SetNetworksFilter {
  static type = '[Networks] Set Networks Filter';

  constructor(public filter: FilterObject<NetworksFilter>) {
  }
}

export class LoadMoreNetworksResults {
  static type = '[Networks] Load More Networks Results';

  constructor(public resetChunk: boolean = false) {
  }
}

export class GetNetworksConfiguration {
  static type = '[Networks] Get Networks Configuration';
}

export class SelectNetwork {
  static type = '[Networks] Select Network';

  constructor(public network: Network) {
  }
}

export class TestController {
  static type = '[Networks] Test Controller';
  constructor(public controller: NetworkController, public networkSubscription$: any) {
  }
}

export class UpdateNetworks {
  static type = '[Networks] Update Networks';
  constructor(public networkUpdate: NetworkStatusSignalR) {
  }
}

export class SetIsPrinting {
  static type = `[Networks] Set Is Printing`;
  constructor(public isPrinting: boolean) {
  }
}
